import { render, staticRenderFns } from "./VatSelector.vue?vue&type=template&id=82dd9b3a&"
import script from "./VatSelector.vue?vue&type=script&lang=js&"
export * from "./VatSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports